

import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button, Col, Row, Card } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const EmployeeModal = ({
  showModal,
  handleClose,
  employeeData,
  addEmployee,
  editEmployee,
  employeeId,
  type
}) => {
  const [formData, setFormData] = useState({
    employee_code: "",
    first_name: "",
    last_name: "",
    gender: "",
    dob: "",
    nationality: "",
    marital_status: "",
    personal_email: "",
    personal_mobile: "",
    emergency_contact_name: "",
    emergency_contact_relation: "",
    emergency_contact_phone: "",
    job_title: "",
    department: "",
    reporting_manager: "",
    work_location: "",
    join_date: "",
    probation_end: "",
    confirmation_date: "",
    employment_type: "",
    department_ids: []
  });

  const [departments, setDepartments] = useState([]);
  const [selectedDeps, setSelectedDeps] = useState([]);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (showModal && !employeeData) {
      // reset form
      setFormData({
        employee_code: "",
        first_name: "",
        last_name: "",
        gender: "",
        dob: "",
        nationality: "",
        marital_status: "",
        personal_email: "",
        personal_mobile: "",
        emergency_contact_name: "",
        emergency_contact_relation: "",
        emergency_contact_phone: "",
        job_title: "",
        department: "",
        reporting_manager: "",
        work_location: "",
        join_date: "",
        probation_end: "",
        confirmation_date: "",
        employment_type: ""
      });
    } else if (employeeData) {
      // edit mode
      setFormData({
        ...employeeData,
        department_ids: employeeData.departments?.map(d => d.id) || []
      });
      setSelectedDeps(employeeData.departments?.map(d => ({ value: d.id, label: d.name })) || []);
    }
  }, [employeeData, showModal]);

  useEffect(() => {
    if (showModal) {
      fetchDepartments();
    }
  }, [showModal]);

  const fetchDepartments = async () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const origin = localStorage.getItem('user-origin');
      const token = userInfo?.token;
      const response = await axios.get(`${backendUrl}/api/departments`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
        },
        skipLoader: true
      });
      if (response.data.status === 'success') {
        setDepartments(response.data.data.map(d => ({ value: d.id, label: d.name })));
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.first_name) newErrors.first_name = "First Name is required";
   
    if (!formData.personal_email) newErrors.personal_email = "Email is required";
    if (!formData.personal_mobile) newErrors.personal_mobile = "Mobile is required";
    if (!formData.emergency_contact_name) newErrors.emergency_contact_name = "Emergency Contact Name is required";
    if (!formData.emergency_contact_phone) newErrors.emergency_contact_phone = "Emergency Contact Phone is required";
    if (!formData.job_title) newErrors.job_title = "Job Title is required";
    if (!formData.join_date) newErrors.join_date = "Join Date is required";
    if (!formData.payment_method) newErrors.payment_method = "Payment method is required";
if (formData.payment_method === "Bank") {
  if (!formData.bank_name) newErrors.bank_name = "Bank Name is required";
  if (!formData.bank_account_no) newErrors.bank_account_no = "Account No is required";
}
if (formData.payment_method === "Exchange") {
  if (!formData.exchange_name) newErrors.exchange_name = "Exchange Name is required";
}


    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      ...formData,
      department_ids: selectedDeps.map(d => d.value)
    };

    let apierrors;
    if (employeeData) {
      apierrors = await editEmployee(employeeId, payload);
    } else {
      apierrors = await addEmployee(payload);
    }

    if (apierrors && Object.keys(apierrors).length > 0) {
      setErrors(apierrors);
    } else {
      setErrors({});
      handleClose();
    }
  };

  return (
    <Offcanvas
      show={showModal}
      onHide={handleClose}
      placement="end"
      style={{ width: "650px" }}
    >
      <Offcanvas.Header closeButton className="bg-light">
        <Offcanvas.Title className="fw-bold">
          {employeeData ? "Edit Employee" : "Add New Employee"}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-4" style={{ overflowY: 'auto' }}>
        <Form onSubmit={handleSubmit}>
          {/* Personal Information Section */}
          <div className="mb-4">
            <h5 className="border-bottom pb-2 mb-3 text-primary">Personal Information</h5>
            <Row>
              {/* <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Employee Code *</Form.Label>
                  <Form.Control
                    type="text"
                    name="employee_code"
                    value={formData.employee_code}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                 
                </Form.Group>
              </Col> */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font"> Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    isInvalid={!!errors.first_name}
                    className="form-control form-feild"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.first_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    name="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Gender</Form.Label>
                  <Form.Select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row> */}

            <Row>
              
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Nationality</Form.Label>
                  <Form.Control
                    type="text"
                    name="nationality"
                    value={formData.nationality}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Employee Category *</Form.Label>
                  <Form.Select
                    name="employee_category"
                    value={formData.employee_category}
                    onChange={handleChange}
                    isInvalid={!!errors.employee_category}
                    className="form-control form-feild"
                  >
                    <option value="">Select Category</option>
                    <option value="Inhouse">Inhouse</option>
                    <option value="Outsourced">Outsourced</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.employee_category}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
<Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Email *</Form.Label>
                  <Form.Control
                    type="email"
                    name="personal_email"
                    value={formData.personal_email}
                    onChange={handleChange}
                    isInvalid={!!errors.personal_email}
                    className="form-control form-feild"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.personal_email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Mobile *</Form.Label>
                  <Form.Control
                    type="text"
                    name="personal_mobile"
                    value={formData.personal_mobile}
                    onChange={handleChange}
                    isInvalid={!!errors.personal_mobile}
                    className="form-control form-feild"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.personal_mobile}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
               <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Work Email *</Form.Label>
                  <Form.Control
                    type="email"
                    name="work_email"
                    value={formData.work_email}
                    onChange={handleChange}
                    isInvalid={!!errors.work_email}
                    className="form-control form-feild"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.work_email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
             
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Work Mobile *</Form.Label>
                  <Form.Control
                    type="text"
                    name="work_mobile"
                    value={formData.work_mobile}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                 
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Emergency Contacts Section */}
          <div className="mb-4">
            <h5 className="border-bottom pb-2 mb-3 text-primary">Emergency Contacts</h5>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font"> Contact Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="emergency_contact_name"
                    value={formData.emergency_contact_name}
                    onChange={handleChange}
                    isInvalid={!!errors.emergency_contact_name}
                    className="form-control form-feild"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.emergency_contact_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Relation</Form.Label>
                  <Form.Control
                    type="text"
                    name="emergency_contact_relation"
                    value={formData.emergency_contact_relation}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font"> Contact Phone *</Form.Label>
                  <Form.Control
                    type="text"
                    name="emergency_contact_phone"
                    value={formData.emergency_contact_phone}
                    onChange={handleChange}
                    isInvalid={!!errors.emergency_contact_phone}
                    className="form-control form-feild"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.emergency_contact_phone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Job Details Section */}
          <div className="mb-4">
            <h5 className="border-bottom pb-2 mb-3 text-primary">Job Details</h5>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Job Title *</Form.Label>
                  <Form.Control
                    type="text"
                    name="job_title"
                    value={formData.job_title}
                    onChange={handleChange}
                    isInvalid={!!errors.job_title}
                    className="form-control form-feild"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.job_title}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Department *</Form.Label>
                  <Select
                    isMulti
                    name="department_ids"
                    options={departments}
                    value={selectedDeps}
                    onChange={setSelectedDeps}
                    classNamePrefix="react-select"
                    placeholder="Select Departments..."
                  />
                  {errors.department_ids && (
                    <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
                      {errors.department_ids}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Reporting Manager</Form.Label>
                  <Form.Control
                    type="text"
                    name="reporting_manager"
                    value={formData.reporting_manager}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Work Location</Form.Label>
                  <Form.Control
                    type="text"
                    name="work_location"
                    value={formData.work_location}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Join Date *</Form.Label>
                  <Form.Control
                    type="date"
                    name="join_date"
                    value={formData.join_date}
                    onChange={handleChange}
                    isInvalid={!!errors.join_date}
                    className="form-control form-feild"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.join_date}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Probation End Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="probation_end"
                    value={formData.probation_end}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Confirmation Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="confirmation_date"
                    value={formData.confirmation_date}
                    onChange={handleChange}
                    className="form-control form-feild"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-label form-font">Employment Type</Form.Label>
                  <Form.Select
                    name="employment_type"
                    value={formData.employment_type}
                    onChange={handleChange}
                    className="form-control form-feild"
                  >
                    <option value="">Select Type</option>
                    <option value="Full-Time">Full-Time</option>
                    <option value="Part-Time">Part-Time</option>
                    <option value="Contract">Contract</option>
                    <option value="Intern">Intern</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </div>
<div className="mb-4">
  <h5 className="border-bottom pb-2 mb-3 text-primary">Bank / Salary Details</h5>
  <Row>
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label className="form-label form-font">Payment Method *</Form.Label>
        <Form.Select
          name="payment_method"
          value={formData.payment_method}
          onChange={handleChange}
          isInvalid={!!errors.payment_method}
          className="form-control form-feild"
        >
          <option value="">Select Method</option>
          <option value="Bank">Bank</option>
          <option value="Exchange">Exchange</option>
        </Form.Select>
        <Form.Control.Feedback type="invalid">
          {errors.payment_method}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>

    {formData.payment_method === "Bank" && (
      <>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label form-font">Bank Name *</Form.Label>
            <Form.Control
              type="text"
              name="bank_name"
              value={formData.bank_name}
              onChange={handleChange}
              isInvalid={!!errors.bank_name}
              className="form-control form-feild"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label form-font">Account No *</Form.Label>
            <Form.Control
              type="text"
              name="bank_account_no"
              value={formData.bank_account_no}
              onChange={handleChange}
              isInvalid={!!errors.bank_account_no}
              className="form-control form-feild"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label form-font">IFSC Code *</Form.Label>
            <Form.Control
              type="text"
              name="ifsc_code"
              value={formData.ifsc_code}
              onChange={handleChange}
              isInvalid={!!errors.ifsc_code}
              className="form-control form-feild"
            />
          </Form.Group>
        </Col>
      </>
    )}

    {formData.payment_method === "Exchange" && (
      <>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label form-font">Exchange Name *</Form.Label>
            <Form.Control
              type="text"
              name="exchange_name"
              value={formData.exchange_name}
              onChange={handleChange}
              isInvalid={!!errors.exchange_name}
              className="form-control form-feild"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label form-font">Reference No</Form.Label>
            <Form.Control
              type="text"
              name="reference_no"
              value={formData.reference_no}
              onChange={handleChange}
              className="form-control form-feild"
            />
          </Form.Group>
        </Col>
      </>
    )}
  </Row>
</div>

          <div className="d-flex justify-content-end mt-4">
            <Button variant="outline-secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EmployeeModal;
